import React from 'react';
import { Box, Flex, Grid } from '@chakra-ui/react';

import { Metadata } from 'src/app/metadata';

import LazyImage from '../lazy-image/lazy-image';

export interface FormLayoutProps {
  /** for meta title */
  title: string;
  children: React.ReactNode;
}

function FormLayout({ title, children }: FormLayoutProps) {
  return (
    <Grid bg="gray.100" placeItems="center">
      <Metadata title={title} />

      <Flex
        justifyContent="center"
        alignItems="center"
        height={['100vh', 'calc(100vh - 70px)']}
        py={5}
        zIndex="0"
      >
        <Flex
          direction={{ base: 'column', md: 'row' }}
          width="100%"
          height={{ base: '100%', md: '600px' }}
          bg="white"
          boxShadow="0px 4px 30px rgba(0, 0, 0, 0.05)"
        >
          <Box
            display={{ base: 'none', md: 'inline-flex' }}
            width={['100%', '450px']}
          >
            <LazyImage
              alt="Register Hero"
              lqip={require('images/assets/login/register-hero.jpg?lqip')}
              src={require('images/assets/login/register-hero.jpg')}
              srcSet="/images/assets/login/register-hero.jpg 1x, /images/assets/login/register-hero@2x.jpg 2x, /images/assets/login/register-hero@3x.jpg 3x"
            />
          </Box>

          <Box
            backgroundColor="white"
            display={{ base: 'inline-flex', md: 'none' }}
            height="140px"
          >
            <LazyImage
              alt="Register Hero Mobile"
              lqip={require('images/assets/login/register-hero-m.jpg?lqip')}
              src={require('images/assets/login/register-hero-m.jpg')}
              srcSet="/images/assets/login/register-hero-m.jpg 1x, /images/assets/login/register-hero-m@2x.jpg 2x, /images/assets/login/register-hero-m@3x.jpg 3x"
            />
          </Box>

          <Box
            pos="relative"
            width={{ base: '100%', md: '450px' }}
            px={[3, 6]}
            py={[4, 8]}
          >
            {children}
          </Box>
        </Flex>
      </Flex>
    </Grid>
  );
}

export default FormLayout;
